import React, { useState } from "react";
import "./PrivacyPolicy.css"; // Change the CSS file name if necessary
import AccordionItem from "./../../components/AccordionItem";

const PrivacyPolicy = () => {
  const [activeSection, setActiveSection] = useState("What is Diamond?");

  const toggleSection = (title) => {
    setActiveSection((prev) => (prev === title ? null : title));
  };

  return (
    <div style={{ backgroundColor: "white" }}>
      <div className="privacy1-container">
        <h1 className="privacy1-title">Privacy Policy</h1>

        {/* Accordion section for detailed terms */}
        <div className="privacy1-content">
          {ppData.map((section) => (
            <AccordionItem
              key={section.title}
              title={section.title}
              content={section.content}
              isActive={activeSection === section.title}
              onToggle={() => toggleSection(section.title)}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;

const ppData = [
  {
    title: "Corporate Business Policy",
    content: (
      <div >
        <div className="containerxyz">
          <div className="text-contentxyz">
            <p className="paragraphxyz">
              We at PANSURIYA IMPEX LLP. are committed to achieving the highest
              level of Ethical, Health Safety, and Environmental Standards.
            </p>
            <p className="paragraphxyz">BY ENSURING THE FOLLOWING ACTIONS:</p>
            <ul className="paragraphxyz">
              <li>
                We ensure Kimberly Process / SOW & Disclosure compliance in all
                our diamond business operations.
              </li>
              <li>
                Strict compliance is ensured at all times, with all applicable
                national and, where appropriate, international laws and
                regulations related to money laundering, terrorism financing,
                bribery, facilitation payments, corruption, smuggling,
                embezzlement, fraud, racketeering, transfer pricing, and tax
                evasion.
              </li>
              <li>
                Compliance with all applicable environmental laws and
                regulations.
              </li>
              <li>
                PANSURIYA IMPEX LLP. is committed to providing safety of
                products throughout its supply chain.
              </li>
              <li>
                PANSURIYA IMPEX LLP. is committed to fighting against
                undisclosed synthetic diamonds.
              </li>
              <li>
                We declare that we do not deal in conflict diamonds and ensure
                to continue the same in the future.
              </li>
              <li>
                Compliance is ensured at all times, with applicable national
                and, where appropriate, international laws/regulations with
                respect to employment and labour.
              </li>
              <li>We will never engage in child labour.</li>
              <li>We will not discriminate in engaging any employee.</li>
              <li>
                The management of PANSURIYA IMPEX LLP is fully committed to
                ensuring that forced or involuntary labour is not practiced in
                any form at any of its facilities.
              </li>
              <li>We ensure strict compliance with health and safety norms.</li>
            </ul>
          </div>
        </div>
      </div>
    ),
  },
  {
    title: "Our Privacy Policy",
    content: (
      <div >
        <div className="containerxyz">
          <div className="text-contentxyz">
            <p className="paragraphxyz">
              At Pansuriya Impex, we are 100% committed to your privacy and the
              security of the information you provide to us during your visit to
              our site.
            </p>
            <p className="paragraphxyz">
              We encourage you to review our policies below to ensure your
              privacy and comfort while visiting and ordering at our website.
            </p>
            <p className="paragraphxyz">
              If you believe that Pansuriya Impex is in breach of our privacy
              policy, please contact us via email at{" "}
              <a href="mailto:net@pansuriyaimpex.com">net@pansuriyaimpex.com</a>
              .
            </p>
          </div>
        </div>
      </div>
    ),
  },
  {
    title: "Collecting Personal Information",
    content: (
      <div >
        <div className="containerxyz">
          <div className="text-contentxyz">
            <p className="paragraphxyz">
              To access our online inventory, we collect your personal
              information for company use only. All information collected by
              Pansuriya Impex is kept confidential.
            </p>
            <p className="paragraphxyz">
              Your email address or contact information will never be sold to
              another company or used for unsolicited (SPAM) emails.
            </p>
            <p className="paragraphxyz">
              We need to share your name and address with the shipping and
              Assurance Company, third-party services, or others for shipping
              and insurance purposes. We aim to provide only the minimum
              required personal data to them.
            </p>
            <p className="paragraphxyz">
              We are not responsible for the misuse of the information by these
              third parties.
            </p>
          </div>
        </div>
      </div>
    ),
  },
  {
    title: "The Use of Cookies",
    content: (
      <div >
        <div className="containerxyz">
          <div className="text-contentxyz">
            <p className="paragraphxyz">
              At Pansuriya Impex, we use cookies to simplify your shopping
              experience. A cookie is a small amount of information that is sent
              to your web browser from our web server. It allows us to remember
              information such as your requested items or items that you have
              added to your shopping basket.
            </p>
            <p className="paragraphxyz">
              If you are not comfortable with enabling cookies in your browser
              preferences, please feel free to call us to request more
              information on items you are interested in or to purchase any
              items listed on our website.
            </p>
            <p className="paragraphxyz">
              No personal or confidential information is ever stored in a cookie
              set by Pansuriya Impex.
            </p>
          </div>
        </div>
      </div>
    ),
  },
  {
    title: "Tracking Visitors",
    content: (
      <div >
        <div className="containerxyz">
          <div className="text-contentxyz">
            <p className="paragraphxyz">
              Pansuriya Impex utilizes methods to track visitors to our site.
              Statistics that we track include what website directed you to us,
              what browser type you use, and what time and date you visited us.
              These statistics are used to help us better serve our customers in
              the future.
            </p>
            <p className="paragraphxyz">
              The Company reserves the right to make any changes to our Terms
              and Conditions and/or our Privacy Policy (which is incorporated
              herein by reference) as we deem necessary or desirable without
              prior notification to you.
            </p>
            <p className="paragraphxyz">
              We suggest that you read our T&C and Privacy Policy from time to
              time in order to stay informed of any such changes. If we make
              changes to our T&C and Privacy Policy and you continue to use our
              Site, you are impliedly agreeing to the revised T&C and Privacy
              Policy expressed herein.
            </p>
          </div>
        </div>
      </div>
    ),
  },
];
